module.exports = __webpack_public_path__ + "static/media/offline.98d27503.gif";